import type { LoaderFunctionArgs } from '@remix-run/node';

import type { MetaFunction } from '@remix-run/react';
import { Link, useLoaderData } from '@remix-run/react';
import { Button } from '~/components/ui/button';
import { Boundary } from '~/components/ui/error';
import { getCurrentUser } from '~/services/auth/config.server';

export const meta: MetaFunction = () => [
  { title: 'tia' },
  {
    description: 'tia'
  }
];

export const ErrorBoundary = Boundary;

export async function loader({ request, response }: LoaderFunctionArgs) {
  const { user } = await getCurrentUser(request, response);

  return { userId: user?.id };
}

export default function Homepage() {
  const { userId } = useLoaderData<typeof loader>();

  return (
    <div className="space-y-4">
      {userId ? (
        <Button className="w-full" asChild>
          <Link to="/dashboard">Dashboard</Link>
        </Button>
      ) : (
        <>
          <Button className="w-full" asChild>
            <Link to="/login">Login</Link>
          </Button>
          <Button className="w-full" asChild>
            <Link to="/register">Register</Link>
          </Button>
        </>
      )}
    </div>
  );
}
